import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Candles from "./pages/Candles";
import ProductDetail from "./pages/ProductDetail";
import ComingSoon from "./pages/ComingSoon";
import About from "./pages/About";
import Contact from "./pages/Contact";
import CartPage from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import Account from "./pages/Account";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const NotFound = () => (
  <div className="flex min-h-[60vh] flex-col items-center justify-center gap-6 px-6 text-center">
    <p className="text-xs uppercase tracking-[0.3em] text-gold">Page Not Found</p>
    <h1 className="font-serif text-4xl text-ink md:text-5xl">This page has drifted away.</h1>
    <Link
      to="/"
      data-testid="not-found-home-link"
      className="border border-cocoa px-8 py-3 text-xs uppercase tracking-[0.25em] text-cocoa transition-colors duration-500 hover:bg-cocoa hover:text-ivory"
    >
      Return Home
    </Link>
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollManager />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/candles" element={<Candles />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/jewellery" element={<ComingSoon kind="jewellery" />} />
              <Route path="/fashion" element={<ComingSoon kind="fashion" />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-success" element={<OrderSuccess />} />
              <Route path="/account" element={<Account />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#2A211A",
                color: "#F3EDE4",
                border: "1px solid rgba(168,117,47,0.4)",
                borderRadius: "0",
                fontFamily: '"DM Sans", sans-serif',
                letterSpacing: "0.05em",
              },
            }}
          />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
